import { styled } from '@mui/material/styles';

import { Tabs } from '@mui/material';

const StyledTabs = styled(Tabs)(({ theme }) => ({
    padding: theme.spacing(0),
    height: 50,
    minHeight: 40,
    borderRadius: 8,
    alignItems: 'center',
    backgroundColor: theme.palette.background.tab,
    '& .Mui-selected': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
    },
    '& .MuiTabs-indicator': {
        display: 'none',
    }
}));

export default StyledTabs;
